import * as React from "react";
import TablePagination from "@mui/material/TablePagination";
import PropTypes from "prop-types";
import CrudService from "services/cruds-service";

export default function TablePaginationDemo({ count, setPageNum }) {
  // const dispatch = useDispatch();
  // const { limit } = useSelector((state) => state.core);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(CrudService.getLimit());

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setPageNum(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    // dispatch(setRowsNum(event.target.value));
    CrudService.setLimit(event.target.value);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      onPageChange={handleChangePage}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100]}
    />
  );
}

TablePaginationDemo.defaultProps = {
  count: null,
  setPageNum: () => null,
};

TablePaginationDemo.propTypes = {
  count: PropTypes.node,
  setPageNum: PropTypes.func,
};
